import React, { useState, useEffect, useRef } from "react";
import "../Navbar/Navbar.css";
import { Link } from "react-router-dom";
import logo from "../../Assets/jkIndia.png"
//import logo from "../../Assets/jklogo.png"
import { useNavigate } from "react-router-dom";
import { FaCaretRight } from 'react-icons/fa';
import AvatarIcon from "../../Common/AvtarIcon/AvtarIconNavbar";
import Swal from 'sweetalert2';
import axios from 'axios';

import {
  ClipboardDocumentCheckIcon,
  BookOpenIcon,
  TruckIcon,
  ChartBarIcon,
  ScaleIcon,
  DocumentTextIcon,
  CurrencyDollarIcon,
  EnvelopeIcon,
  ChevronRightIcon,
  ChevronDownIcon,
  ShoppingCartIcon,
  ReceiptPercentIcon,
  ArrowPathIcon,
  ArrowsRightLeftIcon,
  BanknotesIcon,
  ArrowDownTrayIcon,
  ShoppingBagIcon,
  CreditCardIcon,
  WrenchScrewdriverIcon,
  UserPlusIcon,
  UserGroupIcon,
  FolderIcon,
  CalendarIcon,
  LockOpenIcon,
  MegaphoneIcon,
  BuildingOfficeIcon,
  FolderPlusIcon,
  CalendarDaysIcon,
  CheckBadgeIcon,
  BuildingLibraryIcon,
  LinkIcon,
  MapPinIcon,
  DocumentChartBarIcon,
  UserCircleIcon,
  CogIcon,
  TagIcon,
  GlobeAltIcon,
  DevicePhoneMobileIcon,
  CursorArrowRaysIcon,
  CalculatorIcon,
  ClockIcon,
  ClipboardDocumentListIcon,
  ShieldCheckIcon,
  Squares2X2Icon
} from '@heroicons/react/24/outline';


const API_URL = process.env.REACT_APP_API;

const Navbar = () => {
  const [activeMenu, setActiveMenu] = useState(null);
  const [activeSubMenu, setActiveSubMenu] = useState("");
  const [clickedMenu, setClickedMenu] = useState("");
  const [hoveredSubMenuItem, setHoveredSubMenuItem] = useState("");
  const navbarRef = useRef(null);

  const [username, setUsername] = useState("");
  const companyCode = sessionStorage.getItem("Company_Code")
  const uid = sessionStorage.getItem("uid")
  const [isLoading, setIsLoading] = useState(false);


  useEffect(() => {
    const storedUsername = sessionStorage.getItem("username");
    if (storedUsername) {
      setUsername(storedUsername);
    }
  }, []);

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigate = useNavigate()

  const handleMouseEnter = (menuName) => {
    setActiveMenu(menuName);
    if (!clickedMenu) {
      setActiveSubMenu("");
    }
  };

  const handleSubMouseEnter = (subMenuName) => {
    setActiveSubMenu(subMenuName);
  };

  const handleMouseLeave = (event) => {
    if (navbarRef.current && !navbarRef.current.contains(event.target)) {
      setActiveMenu("");
      setActiveSubMenu("");
      setHoveredSubMenuItem("");
    }
  };

  const handleClick = (menuName) => {
    if (clickedMenu === menuName) {
      setClickedMenu("");
      setActiveMenu("");
      setActiveSubMenu("");
    } else {
      setClickedMenu(menuName);
      setActiveMenu(menuName);
      setActiveSubMenu(menuName);
    }
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setActiveMenu("");
        setActiveSubMenu("");
        setClickedMenu("");
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const handleLogoClick = () => {
    navigate('/dashboard')
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleOpenBalanceStock = () => {
    const url = '/balance-stock';
    window.open(url, '_blank');
  };

  const handleEwaybill = () => {
    const url = '/ewaybill';
    window.open(url, '_blank');
  };

  const handleAnalytics = () => {
    const url = '/Analytics';
    window.open(url, '_blank');
  }


  const handleFundManagement = () => {
    const url = '/fundmanagement';
    window.open(url, '_blank');
  };

  const handleSalryCliked = async () => {
    setIsLoading(true);
    try {
      const userCheckUrl = `${API_URL}/get_user_permissions?Company_Code=${companyCode}&Program_Name=/genratesalary&uid=${uid}`;
      const response = await axios.get(userCheckUrl);
      const userDetails = response.data?.UserDetails;

      if (userDetails?.canView === "Y") {
        window.open("/genratesalary", "_blank");
      } else {
        Swal.fire({
          title: 'Access Denied!',
          text: 'You do not have Permission to view Posting Salary',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      }
    } catch (error) {
      console.error("Error fetching user permissions:", error);
      Swal.fire({
        title: 'Access Denied!',
        text: 'You do not have Permission to view Posting Salary.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    } finally {
      setIsLoading(false);
    }
  };


  const handleBroadCastCliked = async () => {
    setIsLoading(true);
    try {
      const userCheckUrl = `${API_URL}/get_user_permissions?Company_Code=${companyCode}&Program_Name=/send-message&uid=${uid}`;
      const response = await axios.get(userCheckUrl);
      const userDetails = response.data?.UserDetails;

      if (userDetails?.canView === "Y") {
        window.open("/send-message", "_blank");
      } else {
        Swal.fire({
          title: 'Access Denied!',
          text: 'You do not have Permission to view BroadCast Messasges',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      }
    } catch (error) {
      console.error("Error fetching user permissions:", error);
      Swal.fire({
        title: 'Access Denied!',
        text: 'You do not have Permission to view BroadCast Messasges.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleFileSystem = async () => {
    setIsLoading(true);
    try {
      const userCheckUrl = `${API_URL}/get_user_permissions?Company_Code=${companyCode}&Program_Name=/filesystemdashboard&uid=${uid}`;
      const response = await axios.get(userCheckUrl);
      const userDetails = response.data?.UserDetails;

      if (userDetails?.canView === "Y") {
        window.open("/filesystemdashboard", "_blank");
      } else {
        Swal.fire({
          title: 'Access Denied!',
          text: 'You do not have Permission to view File Management.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      }
    } catch (error) {
      console.error("Error fetching user permissions:", error);
      Swal.fire({
        title: 'Access Denied!',
        text: 'You do not have Permission to view File Management.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    } finally {
      setIsLoading(false);
    }
  };


  const handleTrialBalanceScreen = async () => {
    setIsLoading(true);
    try {
      const userCheckUrl = `${API_URL}/get_user_permissions?Company_Code=${companyCode}&Program_Name=/TrialBalancescreen&uid=${uid}`;
      const response = await axios.get(userCheckUrl);
      const userDetails = response.data?.UserDetails;

      if (userDetails?.canView === "Y") {
        window.open("/TrialBalancescreen", "_blank");
      } else {
        Swal.fire({
          title: 'Access Denied!',
          text: 'You do not have Permission to view Trail Balance Screen.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      }
    } catch (error) {
      console.error("Error fetching user permissions:", error);
      Swal.fire({
        title: 'Access Denied!',
        text: 'You do not have Permission to view Trail Balance Screen.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    } finally {
      setIsLoading(false);
    }
  };


  const [clickedSubMenu, setClickedSubMenu] = useState(null);
  const handleSubClick = (menuName) => {
    if (clickedSubMenu === menuName) {
      setClickedSubMenu(null);
      setActiveSubMenu(null);
    } else {
      setClickedSubMenu(menuName);
      setActiveSubMenu(menuName);
    }
  };


  return (
    <>
      <div ref={navbarRef} className="navbar" onMouseLeave={handleMouseLeave}>
        <img className="logo" src={logo} alt="Logo" onClick={handleLogoClick} />
        <div className="nav-item">
          <label
            className="navbarlabel cursor-pointer"
            onMouseEnter={() => handleMouseEnter("company")}
            onMouseLeave={() => {
              if (activeMenu !== "company") {
                setActiveMenu(null);
              }
            }}
            onClick={() => handleClick("company")}
          >
            Company
          </label>

          {activeMenu === "company" && (
            <div
              className="absolute left-0 top-full z-10 mt-3 w-56 rounded-xl bg-white p-2 shadow-lg ring-1 ring-gray-900/5"
              onMouseEnter={() => handleMouseEnter("company")}
              onMouseLeave={() => {
                if (!clickedMenu || clickedMenu !== "company") {
                  setActiveMenu(null);
                }
              }}
            >
              <div className="space-y-1">
                <Link
                  to="/create-utility"
                  className="block rounded-lg px-3 py-2 text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <BuildingOfficeIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Create Company
                </Link>

                <Link
                  to="/select-company"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <CheckBadgeIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Select Company
                </Link>

                <Link
                  to="/create-accounting-year"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <FolderPlusIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Create Accounting Year
                </Link>

                <Link
                  to="/select-accounting-year"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <CalendarDaysIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Select Accounting Year
                </Link>
              </div>
            </div>
          )}
        </div>


        <div className="nav-item">
          <label
            className="navbarlabel cursor-pointer"
            onMouseEnter={() => handleMouseEnter("master")}
            onMouseLeave={() => {
              if (activeMenu !== "master") {
                setActiveMenu(null);
                setActiveSubMenu(null);
              }
            }}
            onClick={() => handleClick("master")}
          >
            Master
          </label>

          {activeMenu === "master" && (
            <div
              className="absolute left-0 top-full z-10 mt-3 w-64 rounded-xl bg-white p-2 shadow-lg ring-1 ring-gray-900/5"
              onMouseEnter={() => handleMouseEnter("master")}
              onMouseLeave={() => {
                if (!clickedMenu || clickedMenu !== "master") {
                  setActiveMenu(null);
                  setActiveSubMenu(null);
                }
              }}
            >
              <div className="space-y-1">
                {/* Account Information Submenu */}
                <div
                  className="relative"
                  onMouseEnter={() => handleSubMouseEnter("accountInfo")}
                  onMouseLeave={() => {
                    if (!clickedSubMenu || clickedSubMenu !== "accountInfo") {
                      setActiveSubMenu(null);
                    }
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSubClick("accountInfo");
                  }}
                >
                  <div className="flex items-center justify-between rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 cursor-pointer">
                    <div className="flex items-center">
                      <UserCircleIcon className="h-5 w-5 mr-2 text-indigo-600" />
                      Account Information
                    </div>
                    <ChevronRightIcon
                      className={`h-4 w-4 transition-transform ${activeSubMenu === "accountInfo" ? "rotate-90" : ""
                        }`}
                    />
                  </div>

                  {activeSubMenu === "accountInfo" && (
                    <div className="absolute left-full top-0 ml-1 w-64 rounded-xl bg-white p-2 shadow-lg ring-1 ring-gray-900/5">
                      <div className="space-y-1">
                        <Link
                          to="/AccountMaster-utility"
                          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                          onClick={() => {
                            setActiveMenu(null);
                            setActiveSubMenu(null);
                          }}
                        >
                          <UserCircleIcon className="h-5 w-5 mr-2 text-indigo-600" />
                          Account Master
                        </Link>
                        <Link
                          to="/CustomerLimit"
                          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                          onClick={() => {
                            setActiveMenu(null);
                            setActiveSubMenu(null);
                          }}
                        >
                          <CursorArrowRaysIcon className="h-5 w-5 mr-2 text-indigo-600" />
                          Customer Limits
                        </Link>
                        <Link
                          to="/financial-groups-utility"
                          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                          onClick={() => {
                            setActiveMenu(null);
                            setActiveSubMenu(null);
                          }}
                        >
                          <BuildingLibraryIcon className="h-5 w-5 mr-2 text-indigo-600" />
                          Financial Groups
                        </Link>
                        <Link
                          to="/city-master-utility"
                          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                          onClick={() => {
                            setActiveMenu(null);
                            setActiveSubMenu(null);
                          }}
                        >
                          <MapPinIcon className="h-5 w-5 mr-2 text-indigo-600" />
                          City Master
                        </Link>
                        <Link
                          to="/PartyUnitMaster-utility"
                          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                          onClick={() => {
                            setActiveMenu(null);
                            setActiveSubMenu(null);
                          }}
                        >
                          <BuildingLibraryIcon className="h-5 w-5 mr-2 text-indigo-600" />
                          Corporate Customer Unit/Godown
                        </Link>
                        <Link
                          to="/ac-master-declaration"
                          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                          onClick={() => {
                            setActiveMenu(null);
                            setActiveSubMenu(null);
                          }}
                        >
                          <DocumentTextIcon className="h-5 w-5 mr-2 text-indigo-600" />
                          Account Master Declaration
                        </Link>
                        <Link
                          to="/bank-details"
                          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                          onClick={() => {
                            setActiveMenu(null);
                            setActiveSubMenu(null);
                          }}
                        >
                          <BanknotesIcon className="h-5 w-5 mr-2 text-indigo-600" />
                          Bank Details
                        </Link>
                      </div>
                    </div>
                  )}
                </div>

                {/* Other Master Submenu */}
                <div
                  className="relative"
                  onMouseEnter={() => handleSubMouseEnter("Other_Master")}
                  onMouseLeave={() => {
                    if (!clickedSubMenu || clickedSubMenu !== "Other_Master") {
                      setActiveSubMenu(null);
                    }
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSubClick("Other_Master");
                  }}
                >
                  <div className="flex items-center justify-between rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 cursor-pointer">
                    <div className="flex items-center">
                      <CursorArrowRaysIcon className="h-5 w-5 mr-2 text-indigo-600" />
                      Other Master
                    </div>
                    <ChevronRightIcon
                      className={`h-4 w-4 transition-transform ${activeSubMenu === "Other_Master" ? "rotate-90" : ""
                        }`}
                    />
                  </div>

                  {activeSubMenu === "Other_Master" && (
                    <div className="absolute left-full top-0 ml-1 w-64 rounded-xl bg-white p-2 shadow-lg ring-1 ring-gray-900/5">
                      <div className="space-y-1">
                        <Link
                          to="/syetem-masterutility"
                          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                          onClick={() => {
                            setActiveMenu(null);
                            setActiveSubMenu(null);
                          }}
                        >
                          <CogIcon className="h-5 w-5 mr-2 text-indigo-600" />
                          System Master
                        </Link>
                        <Link
                          to="/brand-master-utility"
                          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                          onClick={() => {
                            setActiveMenu(null);
                            setActiveSubMenu(null);
                          }}
                        >
                          <TagIcon className="h-5 w-5 mr-2 text-indigo-600" />
                          Brand Master
                        </Link>
                        <Link
                          to="/gst-rate-masterutility"
                          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                          onClick={() => {
                            setActiveMenu(null);
                            setActiveSubMenu(null);
                          }}
                        >
                          <CursorArrowRaysIcon className="h-5 w-5 mr-2 text-indigo-600" />
                          GST Rate Master
                        </Link>
                        <Link
                          to="/gst-state-master-utility"
                          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                          onClick={() => {
                            setActiveMenu(null);
                            setActiveSubMenu(null);
                          }}
                        >
                          <GlobeAltIcon className="h-5 w-5 mr-2 text-indigo-600" />
                          GST State Master
                        </Link>
                      </div>
                    </div>
                  )}
                </div>

                {/* Standalone Menu Items */}
                <Link
                  to="/eway-bill-setting"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => {
                    setActiveMenu(null);
                    setActiveSubMenu(null);
                  }}
                >
                  <DocumentTextIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  eWay Bill Setting
                </Link>
                <Link
                  to="/company-parameter"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => {
                    setActiveMenu(null);
                    setActiveSubMenu(null);
                  }}
                >
                  <BuildingLibraryIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Company Parameter
                </Link>
                <Link
                  to="/whatsapp-api"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => {
                    setActiveMenu(null);
                    setActiveSubMenu(null);
                  }}
                >
                  <DevicePhoneMobileIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  WhatsApp API Integration
                </Link>
              </div>
            </div>
          )}
        </div>


        <div className="nav-item">
          <label
            onMouseEnter={() => handleMouseEnter("inward")}
            onMouseLeave={() => {
              if (!activeMenu === "inward") {
                setActiveMenu(null);
              }
            }}
            onClick={() => handleClick("inward")}
          >
            Inward
          </label>

          {activeMenu === "inward" && (
            <div
              className="absolute -left-8 top-full z-10 mt-3 w-56 rounded-xl bg-white p-2 shadow-lg ring-1 ring-gray-900/5"
              onMouseEnter={() => handleMouseEnter("inward")}
              onMouseLeave={() => {
                // Only close if not clicked to stay open
                if (!clickedMenu || clickedMenu !== "inward") {
                  setActiveMenu(null);
                }
              }}
            >
              <div className="space-y-1">
                <Link
                  to="/sugarpurchasebill-utility"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <CursorArrowRaysIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Purchase Bill
                </Link>
                <Link
                  to="/ShetkariPurchaseBillUtility"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <CursorArrowRaysIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Shetkari Purchase Bill
                </Link>

                <Link
                  to="/OtherGSTInput-utility"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <ReceiptPercentIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Other GST Input
                </Link>
                <Link
                  to="/reverse-charge"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <ArrowPathIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Reverse Charge
                </Link>
                <Link
                  to="/sugar-sale-return-purchase-utility"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <ArrowsRightLeftIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Sugar Sale Return Purchase
                </Link>
              </div>
            </div>
          )}
        </div>

        <div className="nav-item">
          <label
            className="navbarlabel"
            onMouseEnter={() => handleMouseEnter("transactions")}
            onMouseLeave={() => {
              if (!activeMenu === "transactions") {
                setActiveMenu(null);
              }
            }}
            onClick={() => handleClick("transactions")}
          >
            Transactions
          </label>

          {activeMenu === "transactions" && (
            <div
              className="absolute -left-8 top-full z-10 mt-3 w-56 rounded-xl bg-white p-2 shadow-lg ring-1 ring-gray-900/5"
              onMouseEnter={() => handleMouseEnter("transactions")}
              onMouseLeave={() => {
                if (!clickedMenu || clickedMenu !== "transactions") {
                  setActiveMenu(null);
                }
              }}
            >
              <div className="space-y-1">
                <Link
                  to="/RecieptPaymentUtility"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <BanknotesIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Receipt Payment
                </Link>
                <Link
                  to="/JournalVoucher_Utility"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <DocumentTextIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Journal Voucher
                </Link>
                <Link
                  to="/utrentry-Utility"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <CursorArrowRaysIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  UTR Entry
                </Link>
                <Link
                  to="/debitcreditnote-utility"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <ReceiptPercentIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Debit/Credit Note
                </Link>
                <Link
                  to="/other-purchaseutility"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <ShoppingBagIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Other Purchase
                </Link>
                <Link
                  to="/PaymentNote-utility"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <CreditCardIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Payment Note
                </Link>
              </div>
            </div>
          )}
        </div>

        <div className="nav-item">
          <label

            onMouseEnter={() => handleMouseEnter("business-related")}
            onMouseLeave={() => {
              if (!activeMenu === "business-related") {
                setActiveMenu(null);
              }
            }}
            onClick={() => handleClick("business-related")}
          >
            Business Related

          </label>

          {activeMenu === "business-related" && (
            <div
              className="absolute -left-8 top-full z-10 mt-3 w-64 rounded-xl bg-white p-2 shadow-lg ring-1 ring-gray-900/5"
              onMouseEnter={() => handleMouseEnter("business-related")}
              onMouseLeave={() => {
                if (!clickedMenu || clickedMenu !== "business-related") {
                  setActiveMenu(null);
                }
              }}
            >
              <div className="space-y-1 relative">
                {/* Main Menu Items */}
                <Link
                  to="/tender-purchaseutility"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <ClipboardDocumentCheckIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Tender Purchase
                </Link>

                <Link
                  to="/sauda-book-utility-page"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <BookOpenIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Sauda Book Utility
                </Link>

                <Link
                  to="/delivery-order-utility"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <TruckIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Delivery Order
                </Link>


                <Link
                  to="/delivery-order-summary-utility"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <TruckIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Delivery Order Summary
                </Link>

                {/* Nested Stock Report Menu - Now as a flyout */}
                <div
                  className="relative"
                  onMouseEnter={() => handleSubMouseEnter("stock_report")}
                  onMouseLeave={() => {
                    if (!clickedSubMenu || clickedSubMenu !== "stock_report") {
                      setActiveSubMenu(null);
                    }
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleClick("stock_report");
                  }}
                >
                  <label
                    type="button"
                    className="w-full flex items-center justify-between rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200"
                  >
                    <div className="flex items-center">
                      <ChartBarIcon className="h-5 w-5 mr-2 text-indigo-600" />
                      Stock Report
                    </div>
                    <ChevronRightIcon
                      className={`h-4 w-4 text-gray-900 transition-transform ${activeSubMenu === "stock_report" ? "rotate-90" : ""
                        }`}
                    />
                  </label>

                  {/* Flyout submenu */}
                  {activeSubMenu === "stock_report" && (
                    <div className="absolute left-full top-0 ml-1 w-64 rounded-xl bg-white p-2 shadow-lg ring-1 ring-gray-900/5">
                      <div className="space-y-1">
                        <Link
                          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleOpenBalanceStock();
                            setActiveMenu(null);
                          }}
                        >
                          <Squares2X2Icon className="h-5 w-5 mr-2 text-indigo-600 text-gray-900 hover:bg-gray-200" />
                          Balance Stock
                        </Link>

                        <Link
                          to="/register"
                          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                          onClick={() => setActiveMenu(null)}
                        >
                          <DocumentTextIcon className="h-5 w-5 mr-2 text-indigo-600" />
                          Register
                        </Link>

                        <Link
                          to="/profit-loss"
                          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                          onClick={() => setActiveMenu(null)}
                        >
                          <CurrencyDollarIcon className="h-5 w-5 mr-2 text-indigo-600" />
                          Profit Loss
                        </Link>
                      </div>
                    </div>
                  )}
                </div>

                <Link
                  to="/letter"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <EnvelopeIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Letter
                </Link>
              </div>
            </div>
          )}
        </div>


        <div className="nav-item">
          <label
            className="navbarlabel cursor-pointer"
            onMouseEnter={() => handleMouseEnter("outward")}
            onMouseLeave={() => {
              if (activeMenu !== "outward") {
                setActiveMenu(null);
              }
            }}
            onClick={() => handleClick("outward")}
          >
            Outward
          </label>

          {activeMenu === "outward" && (
            <div
              className="absolute left-0 top-full z-10 mt-3 w-56 rounded-xl bg-white p-2 shadow-lg ring-1 ring-gray-900/5"
              onMouseEnter={() => handleMouseEnter("outward")}
              onMouseLeave={() => {
                if (!clickedMenu || clickedMenu !== "outward") {
                  setActiveMenu(null);
                }
              }}
            >
              <div className="space-y-1">
                <Link
                  to="/SaleBill-utility"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <ShoppingCartIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Sale Bill
                </Link>

                <Link
                  to="/ShetkariSaleBillUtility"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <ShoppingCartIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Shetkari Sale Bill
                </Link>

                <Link
                  to="/CommissionBill-utility"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <CursorArrowRaysIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Commission Bill
                </Link>

                <Link
                  to="/sugar-sale-return-sale-utility"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <ArrowPathIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Sugar Sale Return Sale
                </Link>

                <Link
                  to="/Proforma-utility"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <Squares2X2Icon className="h-5 w-5 mr-2 text-indigo-600" />
                  Proforma Service Bill
                </Link>


                <Link
                  to="/ServiceBill-utility"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <Squares2X2Icon className="h-5 w-5 mr-2 text-indigo-600" />
                  Service Bill
                </Link>

                <div
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center cursor-pointer"
                  onClick={(e) => {
                    handleSalryCliked(e);
                    setActiveMenu(null);
                  }}
                >
                  <BanknotesIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Generate Salary
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="nav-item">
          <label
            className="navbarlabel cursor-pointer"
            onMouseEnter={() => handleMouseEnter("reports")}
            onMouseLeave={() => {
              if (activeMenu !== "reports") {
                setActiveMenu(null);
                setActiveSubMenu(null);
              }
            }}
            onClick={() => handleClick("reports")}
          >
            Reports
          </label>

          {activeMenu === "reports" && (
            <div
              className="absolute left-0 top-full z-10 mt-3 w-64 rounded-xl bg-white p-2 shadow-lg ring-1 ring-gray-900/5"
              onMouseEnter={() => handleMouseEnter("reports")}
              onMouseLeave={() => {
                if (!clickedMenu || clickedMenu !== "reports") {
                  setActiveMenu(null);
                  setActiveSubMenu(null);
                }
              }}
            >
              <div className="space-y-1">
                {/* Ledgers Submenu */}
                <div
                  className="relative"
                  onMouseEnter={() => handleSubMouseEnter("ledger")}
                  onMouseLeave={() => {
                    if (!clickedSubMenu || clickedSubMenu !== "ledger") {
                      setActiveSubMenu(null);
                    }
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSubClick("ledger");
                  }}
                >
                  <div className="flex items-center justify-between rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 cursor-pointer">
                    <div className="flex items-center">
                      <BookOpenIcon className="h-5 w-5 mr-2 text-indigo-600" />
                      Ledgers
                    </div>
                    <ChevronRightIcon
                      className={`h-4 w-4 transition-transform ${activeSubMenu === "ledger" ? "rotate-90" : ""
                        }`}
                    />
                  </div>

                  {activeSubMenu === "ledger" && (
                    <div className="absolute left-full top-0 ml-1 w-64 rounded-xl bg-white p-2 shadow-lg ring-1 ring-gray-900/5">
                      <div className="space-y-1">
                        <Link
                          to="/ledger"
                          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                          onClick={() => {
                            setActiveMenu(null);
                            setActiveSubMenu(null);
                          }}
                        >
                          <BookOpenIcon className="h-5 w-5 mr-2 text-indigo-600" />
                          Ledger
                        </Link>
                        <Link
                          to="/daybook"
                          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                          onClick={() => {
                            setActiveMenu(null);
                            setActiveSubMenu(null);
                          }}
                        >
                          <DocumentTextIcon className="h-5 w-5 mr-2 text-indigo-600" />
                          Day Book
                        </Link>
                        <a
                          href="/multiple-ledger"
                          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                          onClick={() => {
                            setActiveMenu(null);
                            setActiveSubMenu(null);
                          }}
                        >
                          <BookOpenIcon className="h-5 w-5 mr-2 text-indigo-600" />
                          Multiple Ledger
                        </a>
                        <Link
                          to="/bank-book"
                          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                          onClick={() => {
                            setActiveMenu(null);
                            setActiveSubMenu(null);
                          }}
                        >
                          <BuildingLibraryIcon className="h-5 w-5 mr-2 text-indigo-600" />
                          Bank Book
                        </Link>
                        <Link
                          to="/account-master-print"
                          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                          onClick={() => {
                            setActiveMenu(null);
                            setActiveSubMenu(null);
                          }}
                        >
                          <ClipboardDocumentListIcon className="h-5 w-5 mr-2 text-indigo-600" />
                          Account Master Print
                        </Link>
                        <Link
                          to="/group-ledger"
                          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                          onClick={() => {
                            setActiveMenu(null);
                            setActiveSubMenu(null);
                          }}
                        >
                          <BookOpenIcon className="h-5 w-5 mr-2 text-indigo-600" />
                          Group Ledger
                        </Link>
                        {/* <Link
                  to="/broker-report"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => {
                    setActiveMenu(null);
                    setActiveSubMenu(null);
                  }}
                >
                  <UserIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Broker Report
                </Link> */}
                        <Link
                          to="/interest-statement"
                          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                          onClick={() => {
                            setActiveMenu(null);
                            setActiveSubMenu(null);
                          }}
                        >
                          <CalculatorIcon className="h-5 w-5 mr-2 text-indigo-600" />
                          Interest Statement
                        </Link>
                      </div>
                    </div>
                  )}
                </div>

                {/* Standalone Report Items */}
                <Link
                  to="/trial-balance"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => {
                    setActiveMenu(null);
                    setActiveSubMenu(null);
                  }}
                >
                  <ScaleIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Trial Balance
                </Link>
                <Link
                  to="/profit-loss-balance-sheet"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => {
                    setActiveMenu(null);
                    setActiveSubMenu(null);
                  }}
                >
                  <ChartBarIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Profit & Loss/Balance Sheet
                </Link>
                <Link
                  to="/stock-book"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => {
                    setActiveMenu(null);
                    setActiveSubMenu(null);
                  }}
                >
                  <BookOpenIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Stock Book
                </Link>
                <Link
                  // to="/TrialBalancescreen"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={(e) => {
                    handleTrialBalanceScreen(e)
                    setActiveMenu(null);
                    setActiveSubMenu(null);
                  }}
                >
                  <ScaleIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Trail Balance Screen
                </Link>
                <Link
                  to="/pending-reports"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => {
                    setActiveMenu(null);
                    setActiveSubMenu(null);
                  }}
                >
                  <ClockIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Pending Reports
                </Link>
                {/* <Link
          to="/retail-sale-register-report"
          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
          onClick={() => {
            setActiveMenu(null);
            setActiveSubMenu(null);
          }}
        >
          <ShoppingCartIcon className="h-5 w-5 mr-2 text-indigo-600" />
          Retail Sale Register Report
        </Link> */}
                {/* <Link
          to="/freight-register-reports"
          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
          onClick={() => {
            setActiveMenu(null);
            setActiveSubMenu(null);
          }}
        >
          <TruckIcon className="h-5 w-5 mr-2 text-indigo-600" />
          Freight Register Reports
        </Link> */}
                {/* <Link
          to="/partiwise-sale-bill-detail-reports"
          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
          onClick={() => {
            setActiveMenu(null);
            setActiveSubMenu(null);
          }}
        >
          <UserGroupIcon className="h-5 w-5 mr-2 text-indigo-600" />
          PartyWise Sale Bill Detail Reports
        </Link> */}
                {/* <Link
          to="/retail-sale-balance-reports"
          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
          onClick={() => {
            setActiveMenu(null);
            setActiveSubMenu(null);
          }}
        >
          <ScaleIcon className="h-5 w-5 mr-2 text-indigo-600" />
          RetailSale Balance Reports
        </Link> */}
                <Link
                  to="/purchase-sale-registers"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => {
                    setActiveMenu(null);
                    setActiveSubMenu(null);
                  }}
                >
                  <DocumentTextIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Purchase Sale Registers
                </Link>
                {/* <Link
          to="/retail-sale-reports"
          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
          onClick={() => {
            setActiveMenu(null);
            setActiveSubMenu(null);
          }}
        >
          <ShoppingCartIcon className="h-5 w-5 mr-2 text-indigo-600" />
          Retail Sale Reports
        </Link> */}
                {/* <Link
          to="/retail-sale-stock-book"
          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
          onClick={() => {
            setActiveMenu(null);
            setActiveSubMenu(null);
          }}
        >
          <BookOpenIcon className="h-5 w-5 mr-2 text-indigo-600" />
          Retail Sale Stock Book
        </Link> */}
                <a
                  href="/multiple-sale-bill-print"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => {
                    setActiveMenu(null);
                    setActiveSubMenu(null);
                  }}
                >
                  <DocumentTextIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Multiple Sale Bill Print
                </a>
                <a
                  href="/partywise-sale-bill-print"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => {
                    setActiveMenu(null);
                    setActiveSubMenu(null);
                  }}
                >
                  <UserGroupIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Partywise Sale Bill Print
                </a>
                {/* <Link
          to="/gst-returns"
          className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
          onClick={() => {
            setActiveMenu(null);
            setActiveSubMenu(null);
          }}
        >
          <ReceiptPercentIcon className="h-5 w-5 mr-2 text-indigo-600" />
          GST Returns
        </Link> */}
              </div>
            </div>
          )}
        </div>

        <div className="nav-item">
          <label
            className="navbarlabel cursor-pointer"
            onMouseEnter={() => handleMouseEnter("utilities")}
            onMouseLeave={() => {
              if (activeMenu !== "utilities") {
                setActiveMenu(null);
              }
            }}
            onClick={() => handleClick("utilities")}
          >
            Utilities
          </label>

          {activeMenu === "utilities" && (
            <div
              className="absolute left-0 top-full z-10 mt-3 w-56 rounded-xl bg-white p-2 shadow-lg ring-1 ring-gray-900/5"
              onMouseEnter={() => handleMouseEnter("utilities")}
              onMouseLeave={() => {
                if (!clickedMenu || clickedMenu !== "utilities") {
                  setActiveMenu(null);
                }
              }}
            >
              <div className="space-y-1">
                <Link
                  to="/user-permission-utility"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <UserPlusIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  User Creation
                </Link>

                <Link
                  to="/group-user-creation"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <UserGroupIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Group User Creation
                </Link>

                <Link
                  to="/Settletenders"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <ShieldCheckIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Settle Tenders
                </Link>

                <Link
                  to="/club-account"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <Squares2X2Icon className="h-5 w-5 mr-2 text-indigo-600" />
                  Club Account
                </Link>

                <Link
                  to="/post-date"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <CalendarIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Post Date
                </Link>

                <Link
                  to="/unlocked-record"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <LockOpenIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Unlock Record
                </Link>

                <div
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center cursor-pointer"
                  onClick={(e) => {
                    handleBroadCastCliked(e);
                    setActiveMenu(null);
                  }}
                >
                  <MegaphoneIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  BroadCast Messages
                </div>

                <div
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center cursor-pointer"
                  onClick={(e) => {
                    handleFileSystem(e);
                    setActiveMenu(null);
                  }}
                >
                  <DocumentTextIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  File Management
                </div>

                <Link
                  to="/fundmanagement"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <DocumentTextIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Fund Management
                </Link>
              </div>
            </div>
          )}
        </div>


        <div className="nav-item" onMouseEnter={() => handleMouseEnter('gst-utilities')}>
          <Link to="/gstutilities" className="nav-link"><label className="navbarlabel">GST Utilities</label></Link>
        </div>

        {/* <div className="nav-item" onMouseEnter={() => handleMouseEnter('eTender')}>
          <Link to="/eBuySugarian-user-utility" className="nav-link"><label className="navbarlabel">eTender</label></Link>
        </div> */}

        <div className="nav-item">
          <label
            className="navbarlabel cursor-pointer"
            onMouseEnter={() => handleMouseEnter("RackRailway")}
            onMouseLeave={() => {
              if (activeMenu !== "RackRailway") {
                setActiveMenu(null);
              }
            }}
            onClick={() => handleClick("RackRailway")}
          >
            Railway Rack
          </label>

          {activeMenu === "RackRailway" && (
            <div
              className="absolute left-0 top-full z-10 mt-3 w-64 rounded-xl bg-white p-2 shadow-lg ring-1 ring-gray-900/5"
              onMouseEnter={() => handleMouseEnter("RackRailway")}
              onMouseLeave={() => {
                if (!clickedMenu || clickedMenu !== "RackRailway") {
                  setActiveMenu(null);
                }
              }}
            >
              <div className="space-y-1">
                <Link
                  to="/RailwayRack-utility"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <BuildingLibraryIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Railway Rack Master
                </Link>

                {/* <Link
                  to="/rack-railway-station-master-utility"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <TruckIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Railway Station Master
                </Link>

                <Link
                  to="/rack-link-railway-station-utility"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <LinkIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Link Railway Station
                </Link>

                <Link
                  to="/rack-from-to-railway-station-rate-utility"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <MapPinIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  From-To Railway Station Rate
                </Link>

                <Link
                  // to="/railway-rack-buy-report"
                  className="block rounded-lg px-3 py-2  text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-200 flex items-center"
                  onClick={() => setActiveMenu(null)}
                >
                  <DocumentChartBarIcon className="h-5 w-5 mr-2 text-indigo-600" />
                  Report
                </Link> */}
              </div>
            </div>
          )}
        </div>

        {/* <div className="nav-item" onMouseEnter={() => handleMouseEnter('companulogs')}>
          <Link to="/companylogs" className="nav-link"><label className="navbarlabel">Company Logs</label></Link>
        </div> */}

        <div className="nav-item" onClick={handleEwaybill}>
          <Link className="nav-link"><label className="navbarlabel">Eway Bill</label></Link>
        </div>

        <div className="nav-item">
          <Link to='/Analytics' className="nav-link"><label className="navbarlabel">Analytics</label></Link>
        </div>

        {/* <div className="nav-item">
          <Link to='/ClosingStock-report' className="nav-link"><label className="navbarlabel">Closing Stock</label></Link>
        </div> */}

        <AvatarIcon style={{ display: "flex" }} />
      </div>
    </>
  );
}

export default Navbar;